module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fileList.length > 0) ? _c('div', [_c('base-tag', {
    attrs: {
      "label": "扫描杆和替代体数据库历史上传"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("正在加载数据...")])]) : _c('div', {
    staticClass: "file-history"
  }, _vm._l((_vm.fileList), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin": "5px 5px"
      },
      on: {
        "click": function($event) {
          return _vm.pushData(item)
        }
      }
    }, [_vm._v("\n     " + _vm._s(item.name) + "\n      "), _c('el-button', {
      staticClass: "btn-download",
      attrs: {
        "type": "text",
        "icon": "el-icon-download"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.downFile(item)
        }
      }
    })], 1)
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-364125dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileHistory.vue
// module id = 633
// module chunks = 0